// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"f53f30ea","67":"daca0ff0","212":"715347a8","625":"43df4d5c"}[chunkId] + ".chunk.css";
};